<template>
  <div
    v-loading="loading"
    element-loading-text="图片上传中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
    class="updateImgCont"
  >
    <!-- 云 -->
    <template v-if="whether == 'true'">
      <el-upload
        class="avatar-uploader-item"
        action="#"
        :show-file-list="false"
        :http-request="httpRequest"
        :accept="accept"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <video
          v-else-if="videoUrl"
          :src="videoUrl"
          class="avatar"
          controls="controls"
          controlslist="nodownload"
        >加载失败</video>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </template>
    <!-- 本地 -->
    <template v-if="whether == 'false'">
      <el-upload
        class="avatar-uploader-item"
        :action="uploadSrc"
        :show-file-list="false"
        :headers="headers"
        :data="fileData"
        :on-success="handleAvatarSuccess"
        :on-change="handleOnChange"
        :accept="accept"
        :before-upload="beforeUpload"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <video
          v-else-if="videoUrl"
          :src="videoUrl"
          class="avatar"
          controls="controls"
          controlslist="nodownload"
        >加载失败</video>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </template>
  </div>
</template>

<script>
import { getRandomInt } from '@/utils/index'
import { uploadFile, getExt } from "@/utils/upload"
import md5 from "js-md5"
import { getToken } from "@/utils/auth"
const schoolid = localStorage.getItem("schoolid") * 1
export default {
  props: {
    // 回显的图片src
    imgSrc: {
      type: String
    },
    // 循环里面得封面用得着
    loops: {
      type: Object
    },
    // 视频
    videoUrl: {
      type: String,
    },
    // 云文件区分
    cloudType: {
      type: String
    },
    // 业务模块名称
    module: {
      type: String,
      default: "",
    },
    accept: { type: String, default: "" }, // 上传文件的类型
  },
  data () {
    return {
      imageUrl: '',
      uploadSrc: process.env.VUE_APP_BASE_API + '/common/upload-file/upload',
      headers: {
        Authorization: getToken() ? "Bearer " + getToken() : "",
        fromtype: 2,
        identifier: 2,
        schoolid: schoolid ? schoolid : 1,
        "app-version": "",
        "request-time": "",
        "request-sign": "",
      },
      // 上传时附带的额外参数
      fileData: {
        module: this.module,
      },
      loading: false,
    }
  },
  watch: {
    imgSrc: {
      handler (val) {
        if (val) {
          this.imageUrl = val
        } else {
          this.imageUrl = ''
        }
      },
      immediate: true
    }
  },
  created () {
    this.whether = sessionStorage.getItem("whether")
    this.setHeaders() // 配置上传默认请求头
  },
  methods: {
    // 配置上传默认请求头
    setHeaders () {
      const date = new Date()
      const c_random = getRandomInt(1, 1000)
      const c_time = date.getTime() + c_random
      const sign_time = c_time.toString()
      const app_version = "v1.0"
      this.headers["app-version"] = app_version
      this.headers["request-time"] = c_time
      this.headers["request-sign"] = md5(md5(sign_time) + app_version)
    },
    handleAvatarSuccess (res, file) {
      if (res.code === 0) {
        this.imageUrl = URL.createObjectURL(file.raw)
        let FileArr = []
        const params = {
          url: file.response.data[0].path,
          name: file.name,
          size: file.size,
          ext: file.response.data[0].ext
        }
        FileArr.push(params)
        if (this.loops) {
          const params = {
            src: FileArr,
            loop: this.loops
          }
          this.$emit('setUrl', params)
        } else {
          this.$emit('setUrl', JSON.stringify(FileArr))
        }
      } else {
        this.$message({
          type: 'error',
          message: res.message
        })
      }
    },
    httpRequest (option) {
      uploadFile(option.file, this.afterupload, this.cloudType)
    },
    // 上传的回调函数
    afterupload (file, data) {
      this.imageUrl = URL.createObjectURL(file)
      const item = {
        url: data.Key,
        name: file.name,
        size: file.size,
        ext: file.name.substring(file.name.lastIndexOf(".") + 1)
      }
      if (this.loops) {
        const params = {
          src: [item],
          loop: this.loops
        }
        this.$emit('setUrl', params)
      } else {
        this.$emit('setUrl', JSON.stringify([item]))
      }
    },
    handleOnChange (res, file) {
      if (res?.response && res.response.code) {
        this.loading = false
        return false
      }
      let condition = res?.status ?? ''
      if (condition.indexOf('success') !== -1) {
        this.$message.success('图片上传成功!')
        this.loading = false
      } else if (condition.indexOf('ready') !== -1) {
        this.loading = true
      } else if (condition.indexOf('error') !== -1) {
        this.$message.error('图片上传失败!')
        this.loading = false
      }
    },
    beforeUpload (file) {
      // this.headers['request-param-key'] = md5(md5(JSON.stringify(this.fileData)) + this.headers['request-sign'] + this.headers["app-version"] + this.headers['fromtype'])
      let isType = null
      isType = ["image/bmp", "image/webp", "image/jpg", "image/jpeg", "image/png", "image/gif"].includes(file.type)
      if (!isType) {
        this.loading = false
        this.$message.error("只能上传图片格式")
      }
      return isType
    },
  }
}
</script>

<style scoped lang="scss">
.avatar-uploader-item .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px dashed #ccc;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #ccc;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>